import config from 'src/config';
import _ from 'lodash';

export default {

  getApiUrl: function (url) {
    return `${config.getApiUrl()}/${url ? _.trimStart(url,"/") : ''}`;
  },

}



// WEBPACK FOOTER //
// ./src/service/ApiService.js